import React, { useState, useRef, useEffect } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import base_url from "../../api/bootapi";
import axios from "axios";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import PrintNote from "./PrintNote";
import ReactDOMServer from "react-dom/server";
import UploadModal from "../../components/Modals/UploadModal";
import MessageModal from "../../components/Modals/MessageModal";
import CustomDOBPicker from "../../components/CustomDOBPicker";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as ChevronRight } from "../../assets/chevron-right.svg";
import { useForm, Controller } from "react-hook-form";
import { DateInput } from "@mantine/dates";
import { ReactComponent as DateIcon } from "../../assets/fi-rr-calendar.svg";
import { DatePicker } from "@mantine/dates";
import { useSelector } from "react-redux";

function ClaimStatus() {
  const [userId, setUserId] = useState("");
  const [claimStatus, setClaimStatus] = useState(null);
  const [backdropopen, setbackdropopen] = useState(false);
  const [showId, setShowId] = useState();
  const navigate = useNavigate();
  const [notes, setNote] = useState();
  const iframeRef = useRef(null);
  const [uploadModalIsOpen, setUploadModalIsOpen] = useState(false);
  const [previousNote, setPreviousNote] = useState("");
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [customerPhone, setCustomerPhone] = useState();
  const [isMultiple, setIsMultiple] = useState(false);
  const [docType, setDocType] = useState("poa");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    control,
    watch,
  } = useForm();

  // Sync form value with `userId` state
  const contactValue = watch("contact"); // Watch the form field
  useEffect(() => {
    setUserId(contactValue || ""); // Update `userId` when form changes
  }, [contactValue]);

  const openMessageModal = () => {
    setIsMessageModalOpen(true);
  };

  const closeMessageModal = () => {
    setIsMessageModalOpen(false);
  };
  const closeUploadModal = () => {
    setUploadModalIsOpen(false);
  };

  const openUploadModal = (isMultiple, docType) => {
    setIsMultiple(isMultiple);
    setDocType(docType);
    setUploadModalIsOpen(true);
  };

  const handlePrint = () => {
    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    // Clear previous content
    doc.body.innerHTML = "";

    // Create a container element for styling
    const container = doc.createElement("div");
    container.style.fontFamily = "Arial, sans-serif";
    container.style.fontSize = "16px";
    container.style.color = "#555";

    //console.log("note", notes);

    // Render StyledNote component as HTML string
    const printNote = <PrintNote note={notes} claimId={showId} />;
    const htmlString = ReactDOMServer.renderToStaticMarkup(printNote);

    // Set the HTML content to the iframe body
    doc.body.innerHTML = htmlString;

    // Focus and print
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };

  const handleUploadDocument = () => {
    navigate("/edit-claim/" + customerId);
  };

  const handleMobileInputChange = (e) => {
    console.log("coming here ------->", e);
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 10) {
      return;
    }
    setUserId(value);
  };

  const getStatusDetails = () => {
    setbackdropopen(true);

    axios
      .get(
        `${base_url.api1}/tourapp/compensation_request?unique_code=${customerPhone}`
      )
      .then((response) => {
        //console.log("31------>", response?.data?.Compensation?.id);
        setbackdropopen(false);
        navigate("/edit-claim/" + response?.data?.Compensation?.id);

        setShowId(response?.data?.Compensation?.contact_no);
        setCustomerId(response?.data?.Compensation?.id);
        setClaimStatus(response?.data?.Compensation?.status.toUpperCase());
        setPreviousNote(response?.data?.Compensation?.note);
        setNote(response?.data?.Compensation?.note);
        setCustomerPhone(response?.data?.Compensation?.contact_no);

        //   setStatus(response.data.status);
      })
      .catch((error) => {
        //console.log("Error");
        setbackdropopen(false);
      });
  };

  const handleCheckStatus = (data) => {
    console.log("coming here 129");

    const [month, day, year] = dateOfBirth.split("-");
    const date_of_birth = year && month && day ? `${year}-${month}-${day}` : "";

    if (!userId || !date_of_birth) {
      return;
    }
    if (claimStatus !== null && userId) {
      setClaimStatus(null);
    }
    setbackdropopen(true);

    axios
      .get(
        `${base_url.api1}/tourapp/compensation_request?unique_code=${data.contact}&date_of_birth=${date_of_birth}`
      )
      .then((response) => {
        console.log("31------>", response?.data);
        setbackdropopen(false);
        navigate("/dashboard", {
          state: { compensationData: response?.data?.Compensation,contact:data.contact, date_of_birth:date_of_birth },
        });
        // navigate("/edit-claim/" + response?.data?.Compensation?.id);
        setUserId("");
        // setShowId(response?.data?.Compensation?.contact_no);
        // setCustomerId(response?.data?.Compensation?.id);
        // setClaimStatus(response?.data?.Compensation?.status.toUpperCase());
        // setPreviousNote(response?.data?.Compensation?.note);
        // setNote(response?.data?.Compensation?.note);
        // setCustomerPhone(response?.data?.Compensation?.contact_no);
        //   setStatus(response.data.status);
      })
      .catch((error) => {
        console.log("Error", error);
        setbackdropopen(false);
        Swal.fire({
          icon: "error",
          title: "No Record Found",
          html: `No record found for claim ID:<strong>${userId}</strong>`,
          confirmButtonText: "Ok",
        });
      });
  };
  const { user } = useSelector((state) => state.user);

  return (
    <div>
      <Nav />
      <div className="modal-wrapper">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <div style={{ margin: "100px 0" }}>
          <div className="check-eligibility-container">
            {/* <div className="breadcrums-container">
              <ul className="breadcrums">
                <Link
                  to="/"
                  className="breadcrums-link"
                  style={{ color: "#799DD2" }}
                >
                  Home
                </Link>
                <ChevronRight />
                <Link className="breadcrums-link" style={{ color: "#565A6D" }}>
                  File a claim
                </Link>
              </ul>
            </div> */}
            {/* <div className="row justify-content-center"> */}
            <div className="claim-status-card-container">
              <div className="">
                <div className="">
                  <form onSubmit={handleSubmit(handleCheckStatus)}>
                    <div className="claim-status-card-body">
                      <h5>Check Your Claim Status</h5>
                      <p>
                        Enter the required information and check your claim
                        status now
                      </p>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <label>
                          Claim ID or Contact Number  <span style={{ color: "#D04244" }}>*</span> <small>  (10 digit phone number)</small>
                        </label>
                        <div className="input-box">
                          <input
                            type="text"
                            className="save-progress-input"
                            placeholder="Claimant's registered ID or mobile number"
                            {...register("contact", {
                              required: "Claim ID is required",
                               pattern: {
      value: /^[0-9-]+$/,
      message: "Only numbers and hyphen (-) are allowed",
    },
                             
                              onChange: (e) => {
                                const sanitizedValue = e.target.value.replace(/[^0-9-]/g, "");
      setValue("contact", sanitizedValue);
      return sanitizedValue;
                              },
                            })}
                            inputMode="numeric"
                          />
                        </div>
                        {errors.contact && (
                          <p className="errormessage">
                            {errors.contact.message}
                          </p>
                        )}
                      </div>

                      {/* <div
                        className="custom-date"
                        style={{ width: "100%" }}
                        ref={dateRef}
                      >
                        <span className="date-label">
                          Date of birth
                          <span style={{ color: "#de8385" }}> *</span>
                        </span>
                        <Controller
                          name="date_of_birth"
                          control={control}
                          rules={{ required: "Date of Birth is Required" }}
                          render={({ field }) => (
                            <>
                              <div
                                className="date-box"
                                onClick={() => setIsOpen(!isOpen)}
                                style={{
                                  borderColor: isOpen ? "#314064" : "#E6F6FF",
                                  backgroundColor: "#e8eef7",
                                }}
                              >
                                <span className="date-text">
                                  {field.value ||
                                    "Choose registered Date of Birth *"}
                                </span>
                              </div>
                              */}
                      {/* <span
                                  className="sub-header"
                                  style={{
                                    color: "#222222",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Select date
                                </span> */}

                      {/* <div
                                    style={{
                                      marginTop: "20px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      gap: "10px",
                                    }}
                                  >
                                    <CustomButton
                                      type="secondary"
                                      btnText="cancel"
                                      flex={true}
                                      onClick={() => {
                                        field.onChange(null);
                                        setIsOpen(false);
                                      }}
                                    />
                                    <CustomButton
                                      btnText="apply"
                                      flex={true}
                                      onClick={() => setIsOpen(false)}
                                    />
                                  </div> */}
                      {/*
                            </>
                          )}
                        />
                        {errors.date_of_birth && (
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {errors.date_of_birth.message}
                          </p>
                        )}
                      </div> */}

                      {/* <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <label>
                          Date of Birth{" "}
                          <span style={{ color: "#D04244" }}>*</span>
                        </label>
                        <div className="input-box">
                          <input
                            type="text"
                            className="save-progress-input"
                            placeholder="Claimant's registered Date of Birth *"
                            onFocus={(e) => {
                              e.target.type = "date";
                              e.target.value = new Date()
                                .toISOString()
                                .split("T")[0];
                            }}
                            onBlur={(e) =>
                              !e.target.value && (e.target.type = "text")
                            }
                            {...register("date_of_birth", { required: true })}
                            required
                          />
                        </div>
                      </div> */}

                      <CustomDOBPicker
                        value={dateOfBirth}
                        onChange={setDateOfBirth}
                        placeholder="Claimant's registered Date of Birth *"
                      />
                      <CustomButton btnText="CHECK STATUS" type="submit" />

                      {/* {!user && (
                        <>
                          <p style={{ textAlign: "center", marginBottom: "0" }}>
                            OR
                          </p>

                          <div>
                            <p
                              onClick={() => navigate("/login")}
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                            >
                              <span
                                style={{ color: "#314064", fontWeight: "700" }}
                              >
                                Login{" "}
                              </span>
                              in to Your Account
                            </p>
                          </div>
                        </>
                      )} */}

                      {claimStatus !== null && (
                        <div className="card mt-3">
                          <div
                            className="card-body"
                            style={{ minHeight: "400px" }}
                          >
                            <h6
                              className="card-title"
                              style={{
                                fontFamily: "Arial, sans-serif",
                                fontSize: "18px",
                                fontWeight: "bold",
                              }}
                            >
                              Claim Status
                            </h6>
                            <p
                              className="card-text"
                              style={{
                                fontFamily: "Arial, sans-serif",
                                fontSize: "16px",
                                color: "#555",
                              }}
                            >
                              The status for your claim ID{" "}
                              <strong>{showId}</strong> is:{" "}
                              <strong>{claimStatus}</strong>
                            </p>
                            {notes && (
                              <div
                                className="mt-3"
                                style={{
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                }}
                              >
                                <h6
                                  className="card-title"
                                  style={{
                                    fontFamily: "Arial, sans-serif",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Note
                                </h6>
                                {notes.map((note, index) => (
                                  <div
                                    key={index}
                                    className="note-item"
                                    style={{ marginBottom: "20px" }}
                                  >
                                    <p
                                      className="note-user"
                                      style={{
                                        fontFamily: "Arial, sans-serif",
                                        fontSize: "16px",
                                        color: "#555",
                                      }}
                                    >
                                      <span
                                        className="note-timestamp"
                                        style={{
                                          fontFamily: "Arial, sans-serif",
                                          fontSize: "14px",
                                          color: "#888",
                                        }}
                                      >
                                        {note.timestamp}
                                      </span>
                                      <br />
                                      From{" "}
                                      {note.user === "customer"
                                        ? "Customer"
                                        : note.user.charAt(0).toUpperCase() +
                                          note.user.slice(1)}
                                      :{" "}
                                      <span
                                        className="note-text"
                                        style={{
                                          fontFamily: "Arial, sans-serif",
                                          fontSize: "16px",
                                          color: "#333",
                                        }}
                                      >
                                        {note.note}
                                      </span>
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              {claimStatus !== null && (
                <>
                  <div className="col-md-2 mt-3">
                    <div style={{ marginBottom: "20px" }}>
                      {" "}
                      <button className="btn btn-success" onClick={handlePrint}>
                        Print
                      </button>
                      <iframe ref={iframeRef} style={{ display: "none" }} />
                    </div>

                    {/* <div style={{ marginBottom: "20px" }}>
                    {" "}
                    <button
                      className="btn btn-primary"
                      onClick={() => openUploadModal(true, "all")}
                    >
                      Upload Doc.
                    </button>
                    <UploadModal
                      isOpen={uploadModalIsOpen}
                      onRequestClose={closeUploadModal}
                      claimId={customerId}
                      isMultiple={isMultiple}
                      docType={docType}
                    />
                  </div> */}
                    <div style={{ marginBottom: "20px" }}>
                      {" "}
                      <button
                        className="btn btn-primary"
                        onClick={() => handleUploadDocument()}
                      >
                        Upload Documents
                      </button>
                      <UploadModal
                        isOpen={uploadModalIsOpen}
                        onRequestClose={closeUploadModal}
                        claimId={customerId}
                        isMultiple={isMultiple}
                        docType={docType}
                      />
                    </div>
                    <div>
                      {" "}
                      <button
                        className="btn btn-danger"
                        onClick={openMessageModal}
                      >
                        Message
                      </button>
                      <MessageModal
                        isOpen={isMessageModalOpen}
                        onRequestClose={closeMessageModal}
                        claimId={customerId}
                        previousNote={previousNote}
                        getStatusDetails={getStatusDetails}
                      />
                    </div>
                    {/* <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                    {" "}
                    <button
                      className="btn btn-primary"
                      onClick={() => openUploadModal(false, "poa")}
                    >
                      Upload POA
                    </button>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    {" "}
                    <button
                      className="btn btn-primary"
                      onClick={() => openUploadModal(false, "agreement")}
                    >
                      Upload Agreement
                    </button>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    {" "}
                    <button
                      className="btn btn-primary"
                      onClick={() => openUploadModal(false, "passport")}
                    >
                      Upload Passport
                    </button>
                  </div> */}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ClaimStatus;
